import Vue from 'vue'
import * as types from './mutation-types'

export default {
  [types.SET_PAGE_TITLE]({ commit }, title) {
    const metaTitle = document.querySelector('meta[property="og:title"]')
    const metaUrl = document.querySelector('meta[property="og:url"]')
    if (title) {
      document.title = `${title}`
    }

    if (metaTitle) {
      metaTitle.setAttribute('content', document.title)
    }

    if (metaUrl) {
      metaUrl.setAttribute('content', window.location.href)
    }

    commit(types.SET_PAGE_TITLE, title)
  },

  [types.SET_PAGE_DESC]({ commit }, desc) {
    const metaDesc = document.querySelector('meta[name="description"]')
                     
    if (metaDesc) {
      document.querySelector('meta[name="description"]').setAttribute("content", desc);
    }

    commit(types.SET_PAGE_DESC, desc)
  },

  [types.SET_PAGE_LANG]({ commit }, lang) {
     if (lang) {
      document.getElementsByTagName('html')[0].lang = lang
     }

    commit(types.SET_PAGE_LANG, lang)
  },
  [types.CHANGE_THEME]({ commit }, theme) {
    Vue.material.theming.theme = theme
    commit(types.CHANGE_THEME, theme)
  }
}
